<template>
  <CommonPages class="rankings" headerTheme="dark" titlePrefix="Rank">
    <div class="ranking-banner"></div>

    <div class="rankings__container">
      <!-- 移动端Tab切换 -->
      <div class="rankings__tabs" v-if="deviceType === 'mobile'">
        <div class="rankings__tab" :class="{'rankings__tab--active': activeTab === 'release'}"
          @click="activeTab = 'release'">
          <div class="rankings__button-icon">
            <img src="@/assets/release-icon.png" alt="release icon">
          </div>
          <span class="rankings__button-text">New Release Cars</span>
        </div>
        <div class="rankings__tab" :class="{'rankings__tab--active': activeTab === 'fastest'}"
          @click="activeTab = 'fastest'">
          <div class="rankings__button-icon">
            <img src="@/assets/fast-icon.png" alt="fast icon">
          </div>
          <span class="rankings__button-text">Top Fastest Cars</span>
        </div>
      </div>

      <!-- PC端标题按钮 -->
      <div class="rankings__title-buttons" v-if="deviceType !== 'mobile'">
        <div class="rankings__button" :class="{
               'rankings__button--active': activeTab === 'release',
               'rankings__button--release': activeTab !== 'release'
             }" @click="activeTab = 'release'">
          <div class="rankings__button-icon">
            <img src="@/assets/release-icon.png" alt="release icon">
          </div>
          <span class="rankings__button-text">New Release Cars</span>
        </div>

        <div class="rankings__button" :class="{
               'rankings__button--active': activeTab === 'fastest',
               'rankings__button--fast': activeTab !== 'fastest'
             }" @click="activeTab = 'fastest'">
          <div class="rankings__button-icon">
            <img src="@/assets/fast-icon.png" alt="fast icon">
          </div>
          <span class="rankings__button-text">Top Fastest Cars</span>
        </div>
      </div>

      <div class="rankings__columns">
        <!-- 左列 - 新发布车辆 -->
        <div class="rankings__column release" v-if="activeTab === 'release'">

          <div class="rankings__cards"
            :class="{'rankings__cards--mobile': deviceType === 'mobile'}">
            <a v-for="(car, index) in releaseRankCars" :key="`new-${index}`"
              class="rankings__card rankings__card--new" :href="getCarDetailUrl(car)">

              <!-- 新发布样式的卡片 -->
              <div class="rankings__new-info">
                <div class="rankings__new-brand-container">
                  <div class="rankings__new-brand">{{ car.brand }}</div>
                  <div class="rankings__new-model">{{ car.model }}</div>
                </div>
                <div class="rankings__new-date">
                  <div class="rankings__new-date-text">{{ car.year }}</div>
                </div>
              </div>

              <div class="rankings__new-image">
                <img :src="car.image" alt="car image" class="rankings__new-img">
              </div>
            </a>

            <!-- 加载更多指示器 - 移动端显示 -->
            <div v-if="releaseLoading && deviceType === 'mobile'" class="rankings__loading-more">
              <div class="rankings__loading-text">Loading more...</div>
            </div>
          </div>
        </div>

        <!-- 右列 - 最快车辆 -->
        <div class="rankings__column fastest" v-if="activeTab === 'fastest'">

          <div class="rankings__cards"
            :class="{'rankings__cards--mobile': deviceType === 'mobile'}">
            <a v-for="(car, index) in fastestRankCars" :key="`fast-${index}`"
              class="rankings__card rankings__card--fast" :href="getCarDetailUrl(car)">

              <!-- 最快车辆样式的卡片 -->
              <div class="rankings__fast-image">
                <img :src="car.image" alt="car image" class="rankings__fast-img">
              </div>

              <div class="rankings__fast-info">
                <div class="rankings__fast-speed-row">
                  <div class="rankings__fast-speed">
                    <div class="rankings__fast-speed-value">{{ car.speedValue }}</div>
                  </div>
                  <div class="rankings__fast-speed-label">
                    <div class="rankings__fast-speed-text">0–60-MPH Times</div>
                  </div>
                </div>

                <div class="rankings__fast-details">
                  <div class="rankings__fast-brand-container">
                    <div class="rankings__fast-brand">{{ car.brand }}</div>
                    <div class="rankings__fast-model">{{ car.model }}</div>
                  </div>
                  <div class="rankings__fast-logo">
                    <img :src="car.logo" alt="brand logo">
                  </div>
                </div>
              </div>
            </a>

            <!-- 加载更多指示器 - 移动端显示 -->
            <div v-if="fastLoading && deviceType === 'mobile'" class="rankings__loading-more">
              <div class="rankings__loading-text">Loading more...</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </CommonPages>
</template>

<script>
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

export default {
  name: 'Rankings',
  components: {
    CommonPages,
  },
  computed: {
    ...mapGetters([
      'deviceType'
    ])
  },
  data () {
    return {
      activeTab: 'release', // 默认显示新发布车辆

      // 新发布榜单数据
      releaseRankCars: [],
      releaseLoading: false,
      releaseError: null,
      releasePageNum: 1,
      releasePageSize: 10,
      releaseHasMore: true,

      // 最快榜单数据
      fastestRankCars: [],
      fastLoading: false,
      fastError: null,
      fastPageNum: 1,
      fastPageSize: 10,
      fastHasMore: true,

    }
  },
  mounted () {
    // 初始加载数据
    this.fetchReleaseRank();
    this.fetchFastRank();
  },
  methods: {
    // 获取新发布车辆排行榜数据
    async fetchReleaseRank () {
      this.releaseLoading = true;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};
        // 获取webIndex
        const webIndex = this.$store.getters.domainConfig?.webIndex || 1;

        const params = {
          pageNum: this.releasePageNum,
          pageSize: this.releasePageSize,
          webIndex, // 添加webIndex字段
          ...themeFilters // 添加主题过滤条件
        };

        const res = await this.$global.server.releaseRank(params);

        if (res.code === 200) {
          // 处理API返回数据
          const apiData = res?.data || [];

          if (apiData.length > 0) {
            const processedData = apiData.map(item => this.formatCarData(item));

            // 追加到现有数据
            this.releaseRankCars = [...this.releaseRankCars, ...processedData];

            // 更新分页信息
            this.releasePageNum++;
            this.releaseHasMore = apiData.length >= this.releasePageSize;

            console.log('[Rankings] 获取发布排行榜数据:', processedData.length);
          } else {
            // 没有更多数据
            this.releaseHasMore = false;
            console.log('[Rankings] 发布排行榜没有更多数据');
          }
        } else {
          throw new Error(res.message || 'Failed to get release rank data');
        }
      } catch (error) {
        console.error('[Rankings] 获取发布排行榜数据错误:', error);
        this.releaseError = error.message;
      } finally {
        this.releaseLoading = false;
      }
    },

    // 获取最快车辆排行榜数据
    async fetchFastRank () {
      this.fastLoading = true;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};
        // 获取webIndex
        const webIndex = this.$store.getters.domainConfig?.webIndex || 1;

        const params = {
          pageNum: this.fastPageNum,
          pageSize: this.fastPageSize,
          webIndex, // 添加webIndex字段
          ...themeFilters // 添加主题过滤条件
        };

        const res = await this.$global.server.fastRank(params);

        if (res.code === 200) {
          // 处理API返回数据
          const apiData = res?.data || [];

          if (apiData.length > 0) {
            const processedData = apiData.map(item => this.formatCarData(item));

            // 追加到现有数据
            this.fastestRankCars = [...this.fastestRankCars, ...processedData];

            // 更新分页信息
            this.fastPageNum++;
            this.fastHasMore = apiData.length >= this.fastPageSize;

            console.log('[Rankings] 获取最快排行榜数据:', processedData.length);
          } else {
            // 没有更多数据
            this.fastHasMore = false;
            console.log('[Rankings] 最快排行榜没有更多数据');
          }
        } else {
          throw new Error(res.message || 'Failed to get fastest rank data');
        }
      } catch (error) {
        console.error('[Rankings] 获取最快排行榜数据错误:', error);
        this.fastError = error.message;
      } finally {
        this.fastLoading = false;
      }
    },

    // 格式化车辆数据
    formatCarData (item) {
      // 格式化车辆数据以便在页面上显示
      const formattedItem = { ...item };

      // 优先使用接口返回的logo，没有则使用默认logo
      formattedItem.logo = item.logoUrl || require('@/assets/car-logo.svg');

      // // 处理图片
      // if (item.photos) {
      //   // 如果photos是字符串（逗号分隔的URL列表），则转换为数组
      //   if (typeof item.photos === 'string') {
      //     const photoArray = item.photos.split(',');
      //     formattedItem.image = photoArray[0]; // 使用第一张图片作为主图
      //     formattedItem.photos = photoArray; // 保存完整图片数组
      //   } else if (Array.isArray(item.photos) && item.photos.length > 0) {
      //     formattedItem.image = item.photos[0];
      //   } else {
      //     formattedItem.image = require('@/assets/car-recommend-img.png');
      //   }
      // } else if (item.image) {
      //   // 如果已经有image字段，保留
      //   formattedItem.image = item.image;
      // } else {
      //   // 使用默认图片
      //   formattedItem.image = require('@/assets/car-recommend-img.png');
      // }

      formattedItem.image = item.cover;

      // 处理模型名称
      if (!formattedItem.model && item.name) {
        formattedItem.model = item.name;
      }

      // 处理年份
      if (!formattedItem.year && item.marketTime) {
        const match = item.marketTime.match(/(\d{4})/);
        if (match) {
          formattedItem.year = match[1];
        } else {
          formattedItem.year = '-';
        }
      } else if (!formattedItem.year) {
        formattedItem.year = '-';
      }

      // 处理价格显示
      formattedItem.price = this.formatPrice(item.leastPrice, item.mostPrice) ||
        (item.price ? `$${this.formatNumber(item.price)}` : 'Price upon request');

      // 处理加速时间
      if (item.accelerationTime) {
        formattedItem.speedValue = `${item.accelerationTime}s`;
      } else if (formattedItem.speedValue && !formattedItem.speedValue.endsWith('s')) {
        formattedItem.speedValue = `${formattedItem.speedValue}s`;
      } else if (!formattedItem.speedValue) {
        formattedItem.speedValue = '-';
      }

      // 确保category和bodyType有值
      if (!formattedItem.category) {
        formattedItem.category = item.purpose || item.type || 'N/A';
      }

      if (!formattedItem.bodyType) {
        formattedItem.bodyType = item.type || 'N/A';
      }

      // 评分
      if (!formattedItem.rate && item.rate) {
        formattedItem.rate = item.rate;
      } else if (!formattedItem.rate) {
        formattedItem.rate = '0.0';
      }

      return formattedItem;
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `$${this.formatNumber(leastPrice)}-$${this.formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `$${this.formatNumber(leastPrice)}+`;
      } else if (mostPrice) {
        // 只有最高价
        return `<$${this.formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 格式化数字为千分位
    formatNumber (num) {
      if (!num) return '0';
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 滚动监听（移动端）
    onScroll () {
      // 如果不在移动端，直接返回
      if (this.deviceType !== 'mobile') return;

      const {
        scrollHeight,
        scrollTop,
        clientHeight
      } = document.documentElement;

      // 检查是否接近底部
      if (scrollHeight - scrollTop - clientHeight < this.scrollThreshold) {
        // 根据当前激活的标签加载更多数据
        if (this.activeTab === 'release' && this.releaseHasMore && !this.releaseLoading) {
          this.fetchReleaseRank();
        } else if (this.activeTab === 'fastest' && this.fastHasMore && !this.fastLoading) {
          this.fetchFastRank();
        }
      }
    },

    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },

    // 生成车辆详情页链接，供真实 a[href] 使用。
    getCarDetailUrl (car) {
      try {
        if (!car || !car.model) {
          return '#';
        }

        const currentChannel = this.$router.currentRoute.params.channel;
        const formattedName = encodeURIComponent(car.model.replace(/\s+/g, '-'));
        const currentQuery = this.$route.query;
        const queryString = new URLSearchParams(currentQuery).toString();
        const fullQueryString = queryString ? `?${queryString}` : '';
        const prefix = currentChannel ? `/${currentChannel}` : '';

        return `${prefix}/cars/${formattedName}/${car.id || '0'}${fullQueryString}`;
      } catch (error) {
        console.error('[Rankings] Detail navigation error:', error);
        return '#';
      }
    },

    // 跳转到所有车辆页面
    gotoAll () {
      // 实现跳转到所有车辆页面的逻辑
      console.log('跳转到所有车辆页面');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';
.ranking-banner {
	width: 100%;
	height: rem(120);
	background: url('~@/assets/ranking-banner.png') no-repeat center center;
	background-size: 100%;
}

.rankings {
	min-height: 100vh;
	position: relative;
	background-position: 0 rem(72);

	&__shadow {
		width: 100%;
		height: rem(330);
		position: absolute;
		top: 0;
		right: 0;
		&--release {
			border-radius: rem(16) rem(16) rem(0) rem(0);
			background: linear-gradient(239deg, rgba(#f7a334, 0.08) 0%, rgba(247, 163, 52, 0) 40.67%);
		}
		&--fast {
			border-radius: rem(16) rem(16) rem(0) rem(0);
			background: linear-gradient(239deg, rgba(#e31837, 0.08) 0%, rgba(227, 24, 55, 0) 40.67%);
		}
	}

	&__container {
		width: 100%;
		padding: rem(40) rem(120);
		max-width: rem(1440);
		margin: 0 auto;
	}

	&__title-buttons {
		display: flex;
		gap: rem(20);
		margin-bottom: rem(40);
	}

	&__button {
		display: flex;
		align-items: center;
		padding: rem(12) rem(24);
		border-radius: rem(12);
		cursor: pointer;
		transition: all 0.3s ease;
		background: #141414;
		color: #ffffff;

		&:hover {
			opacity: 0.7;
		}

		&--active {
			background: var(--theme-color);
			color: #ffffff;
		}
	}

	&__button-icon {
		width: rem(24);
		height: rem(24);
		margin-right: rem(12);
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	&__button-text {
		font-size: rem(16);
		font-weight: 600;
	}

	&__columns {
		display: grid;
		grid-template-columns: 1fr;
		gap: rem(28);
		min-height: rem(600);
	}

	&__column {
		width: 100%;
		position: relative;
	}

	&__cards {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: rem(20);

		&--mobile {
			grid-template-columns: 1fr;
		}
	}

	// 新发布车辆卡片样式
	&__card--new {
		background: #ffffff;
		border-radius: rem(24);
		border: 1px solid #e9e9e9;
		overflow: hidden;
		transition: all 0.3s ease;
		cursor: pointer;
		padding: rem(20);
		gap: rem(20);
		display: flex;
		&:hover {
			transform: translateY(-4px);
		}
	}

	&__new-info {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		height: rem(138);
		width: rem(120);
	}

	&__new-brand-container {
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__new-brand {
		color: #777777;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
	}

	&__new-model {
		color: #141414;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 600;
	}

	&__new-date {
		background: rgba(var(--theme-color-r), var(--theme-color-g), var(--theme-color-b), 0.1);
		border-radius: rem(8);
		padding: rem(10) rem(16);
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
	}

	&__new-date-text {
		color: var(--theme-color);
		font-size: rem(18);
		line-height: rem(20);
		font-weight: 700;
	}

	&__new-image {
		height: rem(138);
		overflow: hidden;
		flex: 1;
		border-radius: rem(16);
		border: 1px solid #fff;
		background: lightgray 50% / cover no-repeat;
	}

	&__new-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(0);
	}

	// 最快车辆卡片样式
	&__card--fast {
		background: linear-gradient(180deg, rgba(20, 20, 20, 0.08) 0%, rgba(255, 255, 255, 0.08) 50.2%, rgba(255, 255, 255, 0.08) 100%);
		border-radius: rem(24);
		border: 1px solid #e9e9e9;
		overflow: hidden;
		transition: all 0.3s ease;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		padding: rem(20);
		gap: rem(16);

		&:hover {
			transform: translateY(-4px);
		}
	}

	&__fast-image {
		width: 100%;
		height: rem(232);
		overflow: hidden;
		border-radius: rem(16);
		border: 1px solid #ffffff;
	}

	&__fast-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__fast-info {
		display: flex;
		flex-direction: column;
		gap: rem(16);
	}

	&__fast-speed-row {
		display: flex;
		align-items: center;
	}

	&__fast-speed {
		background: var(--theme-color);
		border-radius: rem(8) 0 0 rem(8);
		padding: rem(4) rem(12);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__fast-speed-value {
		color: #ffffff;
		font-size: rem(18);
		line-height: rem(20);
		font-weight: 700;
	}

	&__fast-speed-label {
		background: #141414;
		border-radius: 0 rem(8) rem(8) 0;
		padding: rem(4) rem(12);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__fast-speed-text {
		color: #ffffff;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 400;
	}

	&__fast-details {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: space-between;
	}

	&__fast-brand-container {
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__fast-brand {
		color: #777777;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
	}

	&__fast-model {
		color: #141414;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 600;
	}

	&__fast-logo {
		width: rem(40);
		height: rem(40);
		border-radius: 50%;
		background: #ffffff;
		border: 1px solid #e9e9e9;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	&__tabs {
		display: flex;
		width: 100%;
		height: rem(52);
		margin-bottom: rem(20);
		background-color: #fff;
	}

	&__tab {
		flex: 1;
		padding: rem(12) rem(10);
		text-align: center;
		font-size: rem(16);
		color: #848998;
		cursor: pointer;
		position: relative;
		transition: all 0.3s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: rem(12);
		border: 1px solid #e9e9e9;
		background: #fff;

		&--active {
			color: #ffffff;
			font-weight: 700;
			background-color: var(--theme-color);
			border-radius: rem(12);

			&::after {
				display: none;
			}
		}
	}

	&__loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(80);
		width: 100%;
		grid-column: 1 / -1;
	}

	&__loading-text {
		font-size: rem(16);
		line-height: rem(24);
		font-weight: 500;
		color: var(--theme-color);
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.rankings {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.ranking-banner {
		width: 100%;
		height: rem(120);
		background: url('~@/assets/ranking-banner-m.png') no-repeat center center;
		background-size: 100%;
	}

	.rankings {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		background: #fff;

		&__container {
			padding: rem(16) rem(16) rem(20);
		}

		&__tabs {
			gap: rem(12);
		}

		&__columns {
			grid-template-columns: 1fr;
			gap: rem(20);
		}

		&__cards {
			gap: rem(16);
		}

		&__card--new,
		&__card--fast {
			margin-bottom: rem(16);
		}

		&__card--new {
			flex-direction: column;
			gap: rem(16);
		}

		&__new-info {
			// padding: rem(16);
			height: auto;
			order: 2;
			gap: rem(12);
			width: 100%;
		}

		&__new-image {
			height: rem(202);
			order: 1;
		}

		&__fast-image {
			height: rem(203);
		}

		&__fast-speed {
			padding: rem(4) rem(10);
		}

		&__fast-speed-label {
			padding: rem(4) rem(10);
		}

		&__fast-speed-value {
			font-size: rem(16);
		}

		&__fast-speed-text {
			font-size: rem(14);
		}
	}
}
</style>
